import moment from "moment";

export function isNullOrUndefined(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export function getValueOrDefault<T>(value: T | null | undefined, fallback: T): T {
  return isNullOrUndefined(value) ? fallback : value;
}

export function parseNumber(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export function ensureArray<T>(value: T[] | undefined | null): T[] {
  return Array.isArray(value) ? value : [];
}

export function toDayStartMillis(value: unknown): number {
  if (typeof value === "number") {
    return moment(value).startOf("day").valueOf();
  }

  if (typeof value === "string") {
    return moment(value).startOf("day").valueOf();
  }

  return 0;
}

export function toDateInputValue(value: number | string): string {
  return moment(value).format("YYYY-MM-DD");
}

export function parseBool(value: unknown, fallback: boolean): boolean {
  if (typeof value === "boolean") {
    return value;
  }

  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase();
    if (["1", "true", "yes"].includes(normalized)) {
      return true;
    }

    if (["0", "false", "no"].includes(normalized)) {
      return false;
    }
  }

  return fallback;
}

export function makeId(length = 5): string {
  const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";

  for (let i = 0; i < length; i += 1) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }

  return result;
}

export function dayDiff(date1: unknown, date2: unknown): number {
  const a = moment(date2 as moment.MomentInput).startOf("day");
  const b = moment(date1 as moment.MomentInput).startOf("day");
  return Math.floor(a.diff(b, "days", true));
}

export function asObject<T extends Record<string, unknown>>(value: unknown, fallback: T): T {
  return typeof value === "object" && value !== null ? (value as T) : fallback;
}

export function toJsonQuery(value: string): URLSearchParams {
  try {
    const url = new URL(window.location.origin + value);
    return new URLSearchParams(url.search);
  } catch {
    return new URLSearchParams();
  }
}
